import { render, staticRenderFns } from "./registrations-table-mobile-view.vue?vue&type=template&id=6afe7d6b"
import script from "./registrations-table-mobile-view.vue?vue&type=script&lang=js"
export * from "./registrations-table-mobile-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports